import Modal from '@/components/_ui/modal/modal';
import Button from '@/components/_ui/button/button';
import { CheckCircle2 } from 'lucide-react';
import { useCallback } from 'react';
import { useCustomToast } from '@/hooks/use-custom-toast';

export interface ICredentialModalProps {
  webhookKey: string;
  orgId: string;
  onClose?: () => void;
}

export type TCredentialModalType = 'CredentialModal';

const CredentialModal = ({ webhookKey, orgId, onClose }: ICredentialModalProps) => {
  const showToast = useCustomToast();

  const copyToClipboard = useCallback(
    async (value: string, label: string) => {
      await navigator.clipboard.writeText(value);
      showToast({ type: 'success', message: `${label} copied to clipboard` });
    },
    [showToast]
  );

  return (
    <Modal
      isOpen={true}
      isCloseOutside={false}
      isButtonClose={true}
      onClose={onClose || (() => {})}
      className="w-[460px] max-w-[460px]"
    >
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="size-6 text-[#0B8A00] shrink-0" />
            <h3 className="font-bold text-[18px] text-[#0C8DBF]">Registration Successful</h3>
          </div>
          <p className="text-[14px] font-normal text-[#9D9D9C]">
            Your organization has been successfully registered. Please save the credentials below for future integration
            purposes.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <div className="border border-[#D9D9D9] rounded-[8px] p-3 flex items-center justify-between gap-3">
            <div className="flex flex-col gap-3">
              <span className="text-[14px] font-normal tracking-widest text-[#9D9D9C] uppercase">Webhook Key</span>
              <span className="text-[13px] font-normal font-mono text-[#25151E] break-all">{webhookKey}</span>
            </div>
            <button
              onClick={() => copyToClipboard(webhookKey, 'Webhook Key')}
              className="bg-[#0C8DBF] hover:bg-[#0a7aa8] text-white text-[12px] font-medium px-3 py-1 rounded-[6px] shrink-0"
            >
              Copy
            </button>
          </div>

          <div className="border border-[#D9D9D9] rounded-[8px] p-3 flex items-center justify-between gap-3">
            <div className="flex flex-col gap-3">
              <span className="text-[14px] font-normal tracking-widest text-[#9D9D9C] uppercase">Org ID</span>
              <span className="text-[13px] font-normal font-mono text-[#25151E] break-all">{orgId}</span>
            </div>
            <button
              onClick={() => copyToClipboard(orgId, 'Org ID')}
              className="bg-[#0C8DBF] hover:bg-[#0a7aa8] text-white text-[12px] font-medium px-3 py-1 rounded-[6px] shrink-0"
            >
              Copy
            </button>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 pt-1">
          <Button variant="ghost" onClick={onClose} className="text-[#0C8DBF]">
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CredentialModal;
